import { useSelector } from 'react-redux';

import { CHATBOT_ID } from '../constants/chatbotId';
import { chatbotSelector, currentOpenChatSelector } from '../selectors';
import { EPeriodicity } from '../services/fetchChatbotMessages';
import { findLastMessage } from '../utils/findLastMessage';

export enum EChatbotButtons {
  AnswerQuestions = 'answerQuestions',
  ShowAll = 'showAll',
  StopSearch = 'stopSearch',
  SendMore = 'sendMore',
  NewSearch = 'newSearch',
  TunePeriodicity = 'tunePeriodicity',
}

/**
 * Хук для определения порядка кнопок помогатора
 */
export const useChatbotButtons = (isChatbotGPTEnabled: boolean): EChatbotButtons[] => {
  const { hasPollAnswers, periodicity, isPeriodicityMenuOpened } = useSelector(chatbotSelector);
  const currentChat = useSelector(currentOpenChatSelector);

  if (currentChat?.chatId !== CHATBOT_ID || isChatbotGPTEnabled) {
    return [];
  }

  const pagesLength = currentChat.pages.length;
  const messagesLength = currentChat.pages[pagesLength - 1]?.messages.length || 0;

  const lastMessage = findLastMessage({
    chat: currentChat,
    pageIndex: pagesLength - 1,
    messageIndex: messagesLength - 1,
  });

  if ((pagesLength === 1 && messagesLength === 1) || !lastMessage) {
    return [EChatbotButtons.AnswerQuestions];
  }

  if (!hasPollAnswers) {
    if (lastMessage.fromCrm) {
      return [EChatbotButtons.ShowAll, EChatbotButtons.AnswerQuestions, EChatbotButtons.StopSearch];
    }

    return [EChatbotButtons.ShowAll, EChatbotButtons.NewSearch];
  }

  if (periodicity === EPeriodicity.Never) {
    return [EChatbotButtons.SendMore, EChatbotButtons.NewSearch];
  }

  if (isPeriodicityMenuOpened) {
    return [EChatbotButtons.TunePeriodicity];
  }

  return [
    EChatbotButtons.SendMore,
    EChatbotButtons.NewSearch,
    EChatbotButtons.TunePeriodicity,
    EChatbotButtons.StopSearch,
  ];
};
